module.exports = __webpack_public_path__ + "img/2@3x.fe398a40.png";